function formatToFixed(value, digits = 2) {
    return !isNaN(value) && value !== 0 ? value.toFixed(digits) : value;
}

function formatToExponential(value, digits = 2) {
    return !isNaN(value) && value !== 0 ? value.toExponential(digits) : value;
}

export {
    formatToFixed,
    formatToExponential
}